import RenderDateWithFromTime from '@/common-utils/components/renders/date/RenderDateWithFromTime';
import Entity from '@/common-utils/components/renders/entity/Entity';
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import plansFields from '../../../fields/plansFields';
import ColumnSelection from '@/common-utils/components/renders/dataTable/column/ColumnSelection';
import DropdownParentPlansActionsRow from '../../dropdown/DropdownParentPlansActionsRow';

export const columnsParentPlansId = 'parentPlans';

export const columnsParentPlans = (headerPackage) => {

    return ([
        // ColumnSelection
        headerPackage.selectionMode && ColumnSelection(columnsParentPlansId, headerPackage.singleSelection),
        generateColumnDefByField({
            field: plansFields.UUID,
            headerPackage: headerPackage,
            show: !headerPackage.selectionMode && headerPackage.displayRowActions,
            customCellFn: ({ row }) => (
                row &&
                <DropdownParentPlansActionsRow
                    setLaunchRefetch={headerPackage.setLaunchRefetch}
                    parentPlan={row.original}
                    organizationId={headerPackage.organizationId}
                />
            )
        }),
        generateColumnDefByField({
            field: plansFields.LABEL,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: plansFields.PRODUCT_CODE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <Entity entity={cell.getValue(plansFields.PRODUCT_CODE.key)} />
            )
        }),
        generateColumnDefByField({
            field: plansFields.CREATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(plansFields.CREATED_AT.key)} />
            )
        }),
        generateColumnDefByField({
            field: plansFields.UPDATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(plansFields.UPDATED_AT.key)} />
            )
        })
    ]).filter(col => !!col);
};